import { CmsVendor } from "@gatsbyjs/graphql"

export function isSystemVendor(vendor?: CmsVendor) {
  if (!vendor) {
    return false
  }

  return [CmsVendor.None, CmsVendor.Custom, CmsVendor.DataSync].includes(vendor)
}
